/*****components***/
import React, { Component } from "react";

import { Link, Redirect } from "react-router-dom";
/*custom components*/
import PageLoading from "../../components/PageLoading";
import LoginG from "../login/loginG";
import Form from "../../components/Form";
import { toast } from "mdbreact";
import {
  setCustomers,
  getStoresInfo,
  callCustomApi,
  login,
  changeHandler,
  getRenderObj,
  getLoginInfo,
  preloadForm,
  getDefValues,
} from "../../common/functions";
import {
  getS3PublicFile
} from "../../common/functionsV2";
/*functions*/


class page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registerFormData: {},
      registerFormConfig: {},
      successFormData: {},
      successFormConfig: {},
      successForm: false,
      rememberme: true,
      tryOut: false,
      goHome: false,
    };
  }
  /*loading data*/
  componentDidMount = async () => {
    try {
      var login = getLoginInfo();
      if (login.userId != null) {
        this.setState({ isLoading: false, goHome: true });
      } else {
        this.props.hideCart();
        this.setState({ isLoading: true });

        const form1 = await getS3PublicFile(
          process.env.REACT_APP_S3FILES +
          `/public/files/registerForm.json`
        );

        let rendegObj = await getRenderObj(
          form1[0],
          null,
          null,
          null,
          null,
          null,
          null,
          null
        );
        rendegObj.curdata.data.code.maxLength = 12

        this.setState({
          registerFormData: rendegObj.curdata.data,
          registerFormConfig: rendegObj.curdata.config,
          isLoading: false,
        });
        await preloadForm(this.state.registerFormData);

        if (process.env.REACT_APP_ENV === "dev") {
          var originalObj = this.state.registerFormData
          const updated = Object.fromEntries(
            Object.entries(originalObj).map(([key, field]) => {
              let value = field.value;

              if (field.type === "PASSWORD") {
                // Asigna una contraseña genérica del 1 al 8
                value = "Casaideas2025%";
              } else if (field.defaultvalue) {
                // Quita el texto "Ejemplo: " y espacios
                value = field.defaultvalue.replace(/^Ejemplo:\s*/i, "").trim();
              }

              return [key, { ...field, value }];
            })
          );
          this.setState({
            registerFormData: updated
          })
        }

        const successForm = await getS3PublicFile(
          process.env.REACT_APP_S3FILES +
          `/public/files/accountCreatedForm.json`
        );

        rendegObj = await getRenderObj(
          successForm[0],
          null,
          null,
          null,
          null,
          null,
          null,
          null
        );

        this.setState({
          successFormData: rendegObj.curdata.data,
          successFormConfig: rendegObj.curdata.config,
        });
      }
    } catch (Excep) {
      console.log(">>>>>>>", Excep);
      this.setState({ isLoading: false });
    }
  };

  changeHandler = async (event) => {
    if (event.target.name === "rememberme") {
      this.setState({
        rememberme: !this.state.rememberme,
      });
    } else {
      //let resp = await validateForm(this.state.registerFormData, toast, event);
      //this.setState({ registerFormData: resp.formData });

      var formData = changeHandler(event, this.state.registerFormData);
      this.setState({ registerFormData: formData });

      if (event.key === "Enter") {
        this.setCustomers(event);
      }
    }
  };
  responseFacebook = (response) => {
    console.log(response);
  };

  callBackSNError = (res) => {
    console.log("Login failed: res:", res);
  };

  setCustomers = async (event) => {
    try {
      this.setState({ isLoading: true });

      let storeid = await getStoresInfo().selectedStoreId;
      const registerFormData = this.state.registerFormData;
      registerFormData["storeid"] = { value: storeid, name: "storeid" };
      var resp = await setCustomers(this.state.registerFormData, toast);
      console.log("resp", resp)
      this.setState({ successForm: resp.status });
      if (resp.status) {
        let resp = await login(
          this.state.registerFormData,
          this.state.rememberme,
          toast
        );
        try {
          if (this.state.registerFormData.suscribe.value.length > 0) {
            await callCustomApi("suscribe", {
              email: this.state.registerFormData.email.value,
            });
          }
        } catch (Exc) {
          console.log(">>> NEWS ERR", Exc);
        }

        if (resp.status) {
          if (resp.email && resp.email !== "") {
            var objBloomreach_login = {
              email: resp.email,
              firstname: resp.cliente.firstname || "",
              lastname: resp.cliente.lastname || "",
              lastname2: resp.cliente.lastname2 || "",
              opt_in_ofertas: false,
              opt_in_tyc: true,
              origen: "web",
              phone: resp.cliente.phone || "",
              DNI: resp.cliente.code || "",
              birthday: resp.cliente.fecha_nacimiento
              //aqui pueden añadir los otros atributos que puedan obtener al login
            };
            var objBloomreach_setCustomer = {
              registered: resp.code || "", //Este atributo es OBLIGATORIO, Aqui va la identificacion si se tiene si no va vacia NO ES NULL DEBE IR VACIA si va vacio se debe incluir obligatorio el de email_id que es el soft_id
              email_id: resp.email, //Si se tiene el valor se debe añadir
            };
            console.log("BR new");
            window.exponea.track("register", objBloomreach_login);
            window.exponea.update(objBloomreach_login);
            window.exponea.identify(objBloomreach_setCustomer);
            localStorage.setItem(
              process.env.REACT_APP_ORG_NAME + "exponea_registered",
              "YES"
            );
          } else {
            console.log("ALERT!! no email");
          }

          this.props.setLoginInfo(event);
          this.setState({ isLoading: false });
          //this.setState({ goHome: true })
          //window.location.reload();
        }
      } else {
        this.setState({ isLoading: false });
      }
    } catch (Excep) {
      this.setState({ isLoading: false });
      console.log(">>>>>>>", Excep);
    }
  };

  render() {
    return this.props.showSearcher ? (
      ""
    ) : (
      <>
        {this.state.goHome ? <Redirect to={{ pathname: "/" }} /> : ""}
        <PageLoading isLoading={this.state.isLoading} />
        <div className="page-wrapper" onClick={this.props.hideCart}>
          <div className="content container-page custom-container container-fluid ">
            <div
              className={
                "card  mt-30 " + (!this.state.isLoading ? "card-user-info" : "")
              }
            >
              <div className="row mt-30 mb-50 ">
                {this.state.successForm ? (
                  <div
                    className="row"
                    style={{
                      height: this.props.windowHeight - 228 + "px",
                      width: "100%",
                    }}
                  >
                    <div className="mobile-col col-1  col-lg-2"></div>
                    <div className="mobile-col col-11  col-lg-9 mt-3">
                      <Form
                        formData={this.state.successFormData}
                        formConfig={this.state.successFormConfig}
                      />
                    </div>
                    <div className="mobile-col col-12 flex items-center">
                      <Link to="/">
                        <button className="btn btn-primary text-bold">
                          {" "}
                          {getDefValues().gotoStart}{" "}
                        </button>
                      </Link>
                    </div>
                  </div>
                ) : (
                  <div
                    className={
                      "mobile-col col-12 col-sm-12 col-md-9 col-lg-7" +
                      (this.props.windowWidth > 992
                        ? " ml-5 border-right"
                        : " ml-1")
                    }
                  >
                    <div className="row mt-30 mb-30">
                      {!this.state.isLoading ? (
                        <div className="col-12 col-sm-12 col-md-9 col-lg-9 flex items-center">
                          <p className="mobile-col col-12 col-sm-12 col-md-5 col-lg-5 social-login flex items-center">
                            <LoginG
                              customLabel={"Registrate con Google"}
                              setExecuting={() => {
                                this.setState({
                                  isLoading: !this.state.isLoading,
                                });
                              }}
                            />

                          </p>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="mt-30">
                      <Form
                        customClass={"userForm"}
                        formData={this.state.registerFormData}
                        changeHandler={this.changeHandler}
                        formConfig={this.state.registerFormConfig}
                      />
                    </div>
                    {!this.state.isLoading ? (
                      <div className="flex items-left">
                        <div className="col-12 col-lg-9 col-md-12 col-sm-12">
                          <button
                            onClick={this.setCustomers}
                            className="accout-btn btn btn-primary text-bold btn-block"
                          >
                            {" "}
                            {getDefValues().registerLabel}{" "}
                          </button>
                          <div className="row" style={{ margin: "10px 0 0 0" }}>
                            <div className="col-6 flex items-left">
                              <label>
                                <input
                                  name="rememberme"
                                  className="myinput"
                                  checked={this.state.rememberme}
                                  value="YES"
                                  onChange={this.changeHandler}
                                  type="checkbox"
                                />{" "}
                                {getDefValues().remembermeLabel}{" "}
                              </label>
                            </div>
                            <div className="col-6 flex items-right text-underline">
                              <Link to="/customer/account/forgotpassword/">
                                {" "}
                                {getDefValues().forgotPasswordLabel}{" "}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default page;
